<div class="content-panel-sidebar-wrapper">
  <ng-content select="mad-content-panel-container-sidebar"></ng-content>
  <div class="content-panel-outer-wrapper">
    <ng-content select="mad-content-panel-container-content"></ng-content>
    <ng-content select="mad-content-panel-container-footer"></ng-content>
  </div>
</div>
